<div class="progress"
     *ngIf="isSpinnerVisible">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
